import { useMutation, useQueryClient } from '@tanstack/react-query';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';
import { UpdateTourExpenseRequestDto } from '@/features/dashboard/expenses/types/ExpenseRequest.ts';
import { tourDashboardApiQueryKeys } from '@/features/dashboard/tours/api/tourDashboardApi.queryKeys.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';
import { toast } from 'sonner';

export default function useUpdateExpense(tourId: string, expenseId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: UpdateTourExpenseRequestDto) =>
      expensesApi.update(tourId, expenseId, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: expensesApiQueryKeys.byTourId(tourId),
      });
      queryClient.invalidateQueries({
        queryKey: expensesApiQueryKeys.global(),
      });
      queryClient.invalidateQueries({
        queryKey: tourDashboardApiQueryKeys.finance(tourId),
      });
      void invalidateAttentionQueries(queryClient, tourId);
      toast.success('Wydatek został zaktualizowany');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas aktualizacji wydatku.',
      });
    },
  });
}
